import { Link } from "react-router-dom";

function HowItWorks() {
	return (
		<section className="desktopMaxWidth aboutSection howItWorksSection">
			<div className="howItWorksContainers">
				<div className="vision howItWorksContainer">
					<div className="visionTextContainer">
						<p className="tag visionCardTag">How it Works</p>
						<p className="visionText howItWorksText">How our Services Work</p>
					</div>
					<Link to="/contact" className="cta ctaSecondary ctaThird">
						Contact Us
					</Link>
				</div>

				<div className="approachContainer howItWorksContainer">
					<span className="stepsLine">
						<i className="fa-solid fa-1"></i>
						<i className="fa-solid fa-2"></i>
						<i className="fa-solid fa-3"></i>
					</span>
					<div className="approach howItWorks">
						<div className="approachTitleContainer">
							<p className="howItWorksTitle">Book Appointment</p>
						</div>
						<p>
							To schedule an appointment, please complete and submit the form on
							our contact page or reach out to us via phone.
						</p>
					</div>

					<div className="approach howItWorks">
						<div className="approachTitleContainer">
							<p className="howItWorksTitle">Attend Consultation</p>
						</div>
						<p>
							Attend your consultation either in-person or virtually, where I
							will provide tailored care based on your needs.
						</p>
					</div>

					<div className="approach howItWorks">
						<div className="approachTitleContainer">
							<p className="howItWorksTitle">Stay Connected</p>
						</div>
						<p>
							Stay connected for follow-ups and continuous support to ensure
							your health and well-being are on track.
						</p>
					</div>
				</div>
			</div>
		</section>
	);
}

export default HowItWorks;
